import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  static targets = ["hm0_output"];
  connect() {
    super.connect();
    console.log("MARKETING CONTACT LOAD");
    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });

        $("#filterrific_with_compteur_lecture_inf").on("input", function () {
          $("#target_compteur_lecture_inf").val(
            $("#filterrific_with_compteur_lecture_inf").val()
          );
        });
        $("#filterrific_with_compteur_lecture_sup").on("input", function () {
          $("#target_compteur_lecture_sup").val(
            $("#filterrific_with_compteur_lecture_sup").val()
          );
        });

        $("#filterrific_with_compteur_click_inf").on("input", function () {
          $("#target_compteur_click_inf").val(
            $("#filterrific_with_compteur_click_inf").val()
          );
        });
        $("#filterrific_with_compteur_click_sup").on("input", function () {
          $("#target_compteur_click_sup").val(
            $("#filterrific_with_compteur_click_sup").val()
          );
        });

        $("#filterrific_with_compteur_downloads_inf").on("input", function () {
          $("#target_compteur_downloads_inf").val(
            $("#filterrific_with_compteur_downloads_inf").val()
          );
        });
        $("#filterrific_with_compteur_downloads_sup").on("input", function () {
          $("#target_compteur_downloads_sup").val(
            $("#filterrific_with_compteur_downloads_sup").val()
          );
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });

      $("#filterrific_index_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".index_hide").show();
        } else {
          $(".index_hide").hide();
        }
      });

      $("#filterrific_campagne_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".campagne_hide").show();
        } else {
          $(".campagne_hide").hide();
        }
      });

      $("#filterrific_destinataire_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".destinataire_hide").show();
        } else {
          $(".destinataire_hide").hide();
        }
      });

      $("#filterrific_destinataire_type_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".destinataire_type_hide").show();
        } else {
          $(".destinataire_type_hide").hide();
        }
      });

      $("#filterrific_contact2_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".contact2_hide").show();
        } else {
          $(".contact2_hide").hide();
        }
      });

      $("#filterrific_email_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".email_hide").show();
        } else {
          $(".email_hide").hide();
        }
      });

      $("#filterrific_envoye_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".envoye_hide").show();
        } else {
          $(".envoye_hide").hide();
        }
      });

      $("#filterrific_last_sent_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".last_sent_hide").show();
        } else {
          $(".last_sent_hide").hide();
        }
      });

      $("#filterrific_compteur_lecture_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".compteur_lecture_hide").show();
        } else {
          $(".compteur_lecture_hide").hide();
        }
      });

      $("#filterrific_last_opened_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".last_opened_hide").show();
        } else {
          $(".last_opened_hide").hide();
        }
      });

      $("#filterrific_compteur_click_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".compteur_click_hide").show();
        } else {
          $(".compteur_click_hide").hide();
        }
      });

      $("#filterrific_last_clicked_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".last_clicked_hide").show();
        } else {
          $(".last_clicked_hide").hide();
        }
      });

      $("#filterrific_downloaded_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".downloaded_hide").show();
        } else {
          $(".downloaded_hide").hide();
        }
      });

      $("#filterrific_compteur_downloads_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".compteur_downloads_hide").show();
        } else {
          $(".compteur_downloads_hide").hide();
        }
      });

      $("#filterrific_last_download_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".last_download_hide").show();
        } else {
          $(".last_download_hide").hide();
        }
      });

      $("#filterrific_desabonnement_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".desabonnement_hide").show();
        } else {
          $(".desabonnement_hide").hide();
        }
      });

      $("#filterrific_erreur_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".erreur_hide").show();
        } else {
          $(".erreur_hide").hide();
        }
      });
    }
  }

  initZindex() {
    let index = [
      ...document.querySelectorAll("#mySidebar DIV"),
      ...document.querySelectorAll("#mySidebar INPUT"),
      ...document.querySelectorAll("#mySidebar I"),
      ...document.querySelectorAll("#mySidebar SPAN"),
      ...document.querySelectorAll("#mySidebar A"),
    ];

    for (let j = 0; j < index.length; j++) {
      index[j].style.zIndex = 100;
    }
  }

  iniFla() {
    let fields = document.querySelectorAll(".flatpickr");

    for (let j = 0; j < fields.length; j++) {
      fields[j].classList.add("fx-input-date-sidbar-menu");
    }
  }

  toggle() {
    if (this.isopened != 3) {
      this.initZindex();
      this.isopened = 3;
      this.fct($("#mySidebar").css("width") > "0px").then((res) => {
        if (res == true) {
          this.isopened = 1;
        } else {
          this.isopened = 0;
        }
      });
    } else {
      /*********/
    }
  }

  fct(isopened) {
    return new Promise((resolve, reject) => {
      if (isopened) {
        $("#table_custom_").css("display", "none");
        this.closeNav().then(() => {
          setTimeout(function () {
            $("#mySidebar").css("position", "unset");
            $("#main").css("position", "unset");
            main.classList.remove("openbtn_left");
            main.classList.add("openbtn_right");
            $("#mySidebar").css("display", "none");
            resolve(false);
          }, 500);
        });
      } else {
        $("#table_custom_").css("display", "");

        this.openNav().then(() => {
          $("#mySidebar").css("position", "absolute");
          $("#main").css("position", "absolute");
          $("#main").css("marginTop", "0px");
          $("#mySidebar").css("display", "block");
          main.classList.add("openbtn_left");
          main.classList.remove("openbtn_right");
          resolve(true);
        });
      }
    });
  }

  openNav() {
    return new Promise((resolve, reject) => {
      document.getElementById("mySidebar").style.width = "366.8px";
      document.getElementById("main").style.marginRight = "366.8px";
      resolve(true);
    });
  }

  closeNav() {
    return new Promise((resolve, reject) => {
      document.getElementById("mySidebar").style.width = "0px";
      document.getElementById("main").style.margin = "0px";
      resolve(true);
    });
  }
}
